export const CVDESIGNR_LEGAL_NOTICE_URL = 'https://cvdesignr.com/fr/mentions';
